import React, { useEffect, useState } from "react";
import "./draft_Q_list_Activity.css";
import axios from "../../../../../../axios";
import { Link, useLocation, useNavigate } from "react-router-dom";
import CreatePublishActivity from "../../../../Create_Assessment_Activity/create_published/CreatePublishActivity";
import PdfQTypeDRaft from "./PdfQTypeDRaft";
import { Form } from "react-bootstrap";
import AttachActivity from "../../../../Create_Assessment_Activity/create/AttachActivity";
import {
  Box,
  CircularProgress,
  IconButton,
  Stack,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Chip,
  Paper,
  Radio,
  Button,
} from "@mui/material";
import assets from "../../../../../../assets/assets";
import Camera from "react-html5-camera-photo";
import ReportProblemRoundedIcon from "@mui/icons-material/ReportProblemRounded";
import AddLinkPopup from "../../../../../../ContentManagement/LiveSession/LiveSessionDetail.js/SubjectDatailsCM/AddLinkPopup";
import { toast } from "react-toastify";
import { FlaskConical } from "lucide-react";

export default function Draft_Q_list_Activity() {
  const navigate = useNavigate();
  const [click, setClick] = useState(false);
  const { state } = useLocation();
  let Teacher_id = localStorage.getItem("Teacher_id");
  let Teacher_Json = JSON.parse(Teacher_id);

  const [updateActivity, setUpdateActivity] = useState({
    description: "",
    updateTittle: "",
    updateTotalMarks: "",
    updateDeadline: "",
    updateScheduleDate: "",
    updateScheduleTime: "",
    correctAnswer: {
      explanation: "",
      attachment: [],
    },
    attach: [],
  });

  const [isValidFileType2, setIsValidFileType2] = useState(true);
  const [loader, setLoader] = useState(false);
  const [attachMent2, setAttachment2] = useState([]);
  const [loader2, setLoader2] = useState(false);
  const [isValidFileType, setIsValidFileType] = useState(true);
  const [attachState, setAttach] = useState([]);
  const [attachMent, setAttachment] = useState([]);
  const [isCameraOpen, setIsCameraOpen] = useState(false);
  const [errorsize, setErrorSize] = useState(false);
  const [showLinkBox, setShowLinkBox] = useState(false);
  const [linkValue, setLinkValue] = useState("");
  const [cameraError, setCameraError] = useState(null);

  // New state for grades
  const [gradeScales, setGradeScales] = useState([]);
  const [selectedGradeScale, setSelectedGradeScale] = useState(null);
  const [entryType, setEntryType] = useState("Marks");

  /* ── Activity Labs State (single selection) ── */
  const [activityLabsData, setActivityLabsData] = useState([]);
  const [labsLoading, setLabsLoading] = useState(false);
  const [activityLabsOpen, setActivityLabsOpen] = useState(false);
  const [selectedLab, setSelectedLab] = useState(null);
  const [labSearch, setLabSearch] = useState("");
  const [visibleLabsCount, setVisibleLabsCount] = useState(10);
  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );
  const academicSessionId = JSON.parse(
    localStorage.getItem("academicYearSessionId"),
  );
  const schoolId = JSON.parse(localStorage.getItem("schoolId"));

  const {
    description,
    updateTittle,
    updateTotalMarks,
    updateDeadline,
    updateScheduleDate,
    updateScheduleTime,
    attach,
    correctAnswer,
  } = updateActivity;
  const [draftData, setDraftData] = useState({
    draftActivitys: [],
  });
  const { draftActivitys } = draftData;

  // Fetch grade scales
  useEffect(() => {
    const fetchGradeScales = async () => {
      try {
        const res = await axios.get(
          `/api/v1/performance/grade-scales?schoolId=${schoolId}`,
        );
        if (res.data.success && res.data.data.length > 0) {
          setGradeScales(res.data.data);
          // Auto-select first grade scale if available
          setSelectedGradeScale(res.data.data[0]);
        }
      } catch (error) {
        console.error("Error fetching grade scales:", error);
      }
    };
    fetchGradeScales();
  }, []);

  useEffect(() => {
    const getDraftActivity = async () => {
      try {
        const res = await axios.get(
          `/api/v1/homework/activity/getById/${state.draftActivitys_id}`,
        );
        res &&
          setDraftData({
            draftActivitys: res.data.data,
          });

        setUpdateActivity({
          ...updateActivity,
          description: res?.data.data.description,
          updateTittle: res?.data.data.name,
          updateTotalMarks: res?.data.data.total_marks,
          attach: res?.data.data.attachments,
          updateDeadline: res?.data.data.deadline,
          updateScheduleDate: res?.data.data.schedule_date,
          updateScheduleTime: res?.data.data.schedule_time,
          correctAnswer: res?.data.data?.correctAnswer,
        });

        // Set entry type and grade scale from edit data
        if (res?.data?.data?.entryType) {
          setEntryType(res.data.data.entryType);
        }

        // Set selected grade scale if exists
        if (res?.data?.data?.gradeScaleId?._id) {
          // We'll set this after grade scales are loaded
          // Using a separate useEffect below
        }

        // Show already-selected lab if present
        if (res?.data?.data?.lab_ref) {
          setSelectedLab(res.data.data.lab_ref);
        }
      } catch (error) {}
    };
    getDraftActivity();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Set grade scale after grade scales are loaded and draft data is set
  useEffect(() => {
    if (draftActivitys?.gradeScaleId?._id && gradeScales.length > 0) {
      const existingScale = gradeScales.find(
        (scale) => scale._id === draftActivitys.gradeScaleId._id,
      );
      if (existingScale) {
        setSelectedGradeScale(existingScale);
      }
    }
  }, [gradeScales, draftActivitys]);

  useEffect(() => {
    const fetchLabs = async () => {
      try {
        setLabsLoading(true);
        const res = await axios.get("/api/v1/labActivity/get");
        setActivityLabsData(res?.data?.data || []);
      } catch (error) {
        console.log(error);
        setActivityLabsData([]);
      } finally {
        setLabsLoading(false);
      }
    };
    fetchLabs();
  }, []);

  useEffect(() => {
    setVisibleLabsCount(10);
  }, [labSearch]);

  let createActivityDraft = {
    standard_id: draftActivitys?.standard_id?.id,
    subject_id: draftActivitys?.subject_id?.id,
    section_id: draftActivitys?.section_id?.id,
    book_id: draftActivitys?.book_id?.id,
    chapter_id: draftActivitys?.chapter_id?.id,
    teacher_id: Teacher_Json,
    academic_session_id: academicSessionId,
    timetable_session_id: timeTableSessionId,
    status: "draft",
    description: description,
    name: updateTittle,
    total_marks: updateTotalMarks,
    attachments: attach,
    difficulty_level: draftActivitys?.difficulty_level?.id,
    deadline: updateDeadline,
    schedule_date: updateScheduleDate,
    schedule_time: updateScheduleTime,
    activity_type: selectedLab ? "Lab" : draftActivitys?.activity_type,
    lab_ref_id: selectedLab?.id,
    correctAnswer: {
      explanation: correctAnswer.explanation,
      attachment: updateActivity.correctAnswer.attachment || [],
      attachments_sizeKb: attachMent.map((file) =>
        Math.round(file.size / 1024),
      ),
    },
    // New fields for marks/grades
    entryType: entryType,
    gradeScaleId: entryType === "Grade" ? selectedGradeScale?._id : null,
    rubricScaleId: null,
  };

  const validateFileTypeForCorrectAns = (filePath) => {
    var allowedExtensions =
      /(\.jpg|\.jpeg|\.png|\.pdf|\.mp3|\.mp4|\.pptx|\.ppt)$/i;

    if (!allowedExtensions.exec(filePath.name) || attach.length >= 5) {
      setIsValidFileType2(false);
      return false;
    }
    setIsValidFileType2(true);
    return true;
  };

  const validateFileType = (filePath) => {
    var allowedExtensions =
      /(\.jpg|\.jpeg|\.png|\.pdf|\.mp3|\.mp4|\.pptx|\.ppt)$/i;

    if (!allowedExtensions.exec(filePath.name) || attachState.length >= 5) {
      setIsValidFileType(false);
      return false;
    }
    setIsValidFileType(true);
    return true;
  };

  function checkFileSize(event) {
    console.log("A");
    const file = event.target.files[0];
    if (!file) {
      setLoader2(false);
      return;
    }
    const maxSize = 10 * 1024 * 1024; // 10MB in bytes
    let totalSize = attachMent.reduce((acc, file) => acc + file.size, 0);
    setLoader2(true);
    if (file.size > maxSize) {
      setLoader2(false);
      setIsValidFileType(true);
      event.target.value = ""; // Clear the selected file
    } else {
      if (totalSize + file.size <= 10 * 1024 * 1024 && validateFileType(file)) {
        const file = event.target.files[0];
        const formData = new FormData();
        formData.append("uploadActivityAttachment", file);
        axios
          .post(
            `/api/v1/homework/activity/uploadAttachment/teacherId/${Teacher_Json}`,
            formData,
          )
          .then((response) => {
            setAttach([...attach, response.data.data]);
            setAttachment((prev) => [...prev, file]);
            setUpdateActivity((prevState) => ({
              ...prevState,
              correctAnswer: {
                ...prevState.correctAnswer,
                attachment: [
                  ...prevState.correctAnswer.attachment,
                  response.data.data,
                ],
              },
            }));
            response && setLoader2(false);
          })
          .catch((error) => {
            console.error("Error uploading file:", error);
            setLoader2(false);
          });
      } else {
        setIsValidFileType(false);
        setLoader2(false);
      }
    }
    // setLoader(false);
    event.target.value = "";
  }

  function checkFileSizeForAns(event) {
    console.log("B");
    const file = event.target.files[0];
    const maxSize = 10 * 1024 * 1024;
    let totalSize = attachMent2.reduce((acc, file) => acc + file.size, 0);
    setLoader(true);
    if (file.size > maxSize) {
      event.target.value = "";
    } else {
      if (
        totalSize + file.size <= 10 * 1024 * 1024 &&
        validateFileTypeForCorrectAns(file)
      ) {
        const file = event.target.files[0];
        const formData = new FormData();
        formData.append("uploadActivityAttachment", file);
        axios
          .post(
            `/api/v1/homework/activity/uploadAttachment/teacherId/${Teacher_Json}`,
            formData,
          )
          .then((response) => {
            setAttachment2((prev) => [...prev, file]);
            setUpdateActivity((prevState) => ({
              ...prevState,
              attach: [...prevState.attach, response.data.data],
            }));
            response && setLoader(false);
          })
          .catch((error) => {
            setLoader(false);
            console.error("Error uploading file:", error);
          });
      } else {
        setIsValidFileType2(false);
        setLoader(false);
      }
    }
  }

  async function handleTakePhoto(dataUri) {
    const now = new Date();

    // Format date parts
    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = now.getFullYear();

    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    const fileExtension = "jpg" || "jpeg" || "png";
    const filename = `capture-${day}-${month}-${year}-${hours}:${minutes}:${seconds}.${fileExtension}`;
    console.log("filename", filename);

    const link = document.createElement("a");
    link.href = dataUri;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    try {
      const capture = await fetch(dataUri).then((res) => res.blob());
      const fileWithProperExtension = new File([capture], filename, {
        type: capture.type || "image/jpeg",
      });

      if (
        fileWithProperExtension.size <= 25 * 1024 * 1024 &&
        validateFileType(fileWithProperExtension)
      ) {
        const formData = new FormData();
        formData.append("name", filename);
        formData.append("uploadActivityAttachment", fileWithProperExtension);

        let response = await axios.post(
          `/api/v1/homework/activity/uploadAttachment/teacherId/${Teacher_Json}`,
          formData,
        );

        if (response) {
          setUpdateActivity((prevState) => ({
            ...prevState,
            attach: [...prevState.attach, response.data.data],
          }));
          response && setLoader(false);
        } else {
          console.error("Failed to upload photo:", response.statusText);
          alert("Failed to upload photo.");
        }
      } else {
        setIsValidFileType(false);
      }
    } catch (error) {
      console.error("Error uploading photo:", error);
      alert("An error occurred during the upload.");
    } finally {
      setIsCameraOpen(false);
    }
  }

  const helper = async () => {
    try {
      let res = await axios.post(
        `/api/v1/homework/activity/update/${draftActivitys.id}`,
        createActivityDraft,
      );
      console.log("resfff", res);
      navigate("/PublishedHomeworkActivity");
    } catch (error) {
      console.log(error);
    }
  };

  const isDisableDraft =
    updateActivity.updateTittle === "" || updateActivity.description === "";
  const isDisablePublish =
    updateActivity.updateTotalMarks === "" ||
    updateActivity.updateTittle === "" ||
    updateActivity.description === "";

  const titleRejex = /^\s+/;
  const descriptionRejex = /^\s+/;

  const errors = {};
  if (updateTittle === (titleRejex.test(updateTittle) && updateTittle)) {
    errors.updateTittle = "Tittle can not start with a space";
  }
  if (description === (descriptionRejex.test(description) && description)) {
    errors.description = "Description can not start with a space";
  }

  const onChangeLinkValue = (value) => {
    setLinkValue(value);
  };

  const handleSaveLink = () => {
    if (linkValue.trim() === "" || !linkValue.startsWith("https://")) {
      toast.error("Please enter a valid link.");
      return;
    }

    setUpdateActivity((prev) => {
      const prevAttach = Array.isArray(prev.attach) ? prev.attach : [];
      return {
        ...prev,
        attach: [...prevAttach, linkValue],
      };
    });
    setLinkValue("");
    setShowLinkBox(false);
  };

  const filteredLabs = activityLabsData.filter((lab) => {
    const matchesSearch =
      (lab.title || "").toLowerCase().includes(labSearch.toLowerCase()) ||
      (lab.description || "").toLowerCase().includes(labSearch.toLowerCase());

    return matchesSearch;
  });

  console.log("updateActivity", updateActivity);

  return (
    <div
      className="orange-scrollBar"
      style={{ maxHeight: "600px", overflowY: "scroll" }}
    >
      <div>
        <div className="d-flex align-items-center ">
          <Link to="/PublishedHomeworkActivity" className="link">
            <img src="/images/Back Arrow.svg" alt=""></img>
          </Link>
          <Link to="/PublishedHomeworkActivity" className="link">
            <span className="open_publish_path">
              &nbsp;{" "}
              {draftActivitys?.status === "draft"
                ? "Draft"
                : draftActivitys?.status}{" "}
              /&nbsp;
            </span>
          </Link>
          <span className="open_publish_path1"> {draftActivitys?.name}</span>
        </div>
        <div className="mt-3 publishsub_heading"> {draftActivitys?.name}</div>

        <div className="p-0 col-11">
          <div className="d-flex align-items-center justify-content-between">
            <div className="sub_heading_activityDraft">
              Create fun activity for the students here.
            </div>
            <div className="d-flex align-items-center gap-2">
              {/* Marks Input - Always visible */}

              {/* Grade Selection - Only show if grade scales data is available */}
              {gradeScales.length > 0 && (
                <>
                  <div className="d-flex align-items-center gap-2">
                    <span className="fw-medium" style={{ fontSize: "14px" }}>
                      Entry:
                    </span>
                    <select
                      className="form-select form-select-sm"
                      value={entryType}
                      onChange={(e) => {
                        const value = e.target.value;
                        setEntryType(value);
                        if (value === "Marks" && gradeScales.length > 0) {
                          setSelectedGradeScale(gradeScales[0]);
                        }
                      }}
                      style={{ width: "100px", borderRadius: "8px" }}
                    >
                      <option value="Marks">Marks</option>
                      <option value="Grade">Grade</option>
                    </select>
                  </div>

                  {entryType === "Grade" && (
                    <div className="d-flex align-items-center gap-2">
                      <span className="fw-medium" style={{ fontSize: "14px" }}>
                        Grade:
                      </span>
                      <select
                        className="form-select form-select-sm"
                        value={selectedGradeScale?._id || ""}
                        onChange={(e) => {
                          const selected = gradeScales.find(
                            (scale) => scale._id === e.target.value,
                          );
                          setSelectedGradeScale(selected || null);
                        }}
                        style={{ width: "150px", borderRadius: "8px" }}
                      >
                        <option value="">Select Grade Scale</option>
                        {gradeScales.map((scale) => (
                          <option key={scale._id} value={scale._id}>
                            {scale.name}
                          </option>
                        ))}
                      </select>
                      {selectedGradeScale && (
                        <div className="d-flex gap-1">
                          {selectedGradeScale.grades.map((grade) => (
                            <span
                              key={grade.grade}
                              className="badge"
                              style={{
                                backgroundColor:
                                  grade.resultStatus === "Pass"
                                    ? "#d4edda"
                                    : "#f8d7da",
                                color:
                                  grade.resultStatus === "Pass"
                                    ? "#155724"
                                    : "#721c24",
                                padding: "4px 8px",
                                borderRadius: "4px",
                                fontSize: "11px",
                              }}
                            >
                              {grade.grade}: {grade.minMarks}-{grade.maxMarks}
                            </span>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}

              {entryType === "Marks" && (
                <div className="d-flex align-items-center gap-2">
                  <span>Marks</span>
                  <input
                    id="addMarks"
                    value={updateTotalMarks}
                    type="number"
                    className="form-control txt_draft3"
                    placeholder="Add Marks"
                    style={{ width: "120px" }}
                    onChange={(e) =>
                      setUpdateActivity({
                        ...updateActivity,
                        updateTotalMarks: e.target.value,
                      })
                    }
                  />
                </div>
              )}
            </div>
          </div>

          <div className="ms-5">
            <input
              type="text"
              maxLength={50}
              value={updateTittle}
              placeholder="Enter title"
              className="txt_draft1 mt-3 form-control"
              id="txt-i-first"
              onChange={(e) =>
                setUpdateActivity({
                  ...updateActivity,
                  updateTittle: e.target.value,
                })
              }
            />
            {errors.updateTittle && (
              <span className="error">{errors.updateTittle}</span>
            )}

            <Form.Control
              as="textarea"
              placeholder="Enter Description"
              maxLength={300}
              value={description}
              rows={4}
              className="px-3 py-2 mt-4 txt_draft2"
              onChange={(e) =>
                setUpdateActivity({
                  ...updateActivity,
                  description: e.target.value,
                })
              }
            />
            {errors.description && (
              <span className="error">{errors.description}</span>
            )}

            {/* ── Selected Activity Lab (full width, below description) ── */}
            {selectedLab && (
              <Paper
                elevation={0}
                sx={{
                  mt: 2,
                  mb: 3,
                  p: 2.5,
                  borderRadius: 3,
                  border: "2px solid #6366f1",
                  backgroundColor: "#f5f3ff",
                  display: "flex",
                  alignItems: "center",
                  gap: 2.5,
                  width: "100%",
                }}
              >
                <Box
                  sx={{
                    width: 140,
                    height: 90,
                    flexShrink: 0,
                    borderRadius: 2,
                    overflow: "hidden",
                    border: "1px solid #c4b5fd",
                    boxShadow: "0 2px 8px rgba(99,102,241,0.15)",
                  }}
                >
                  <img
                    src={selectedLab.thumbnailUrl}
                    alt={selectedLab.title}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                  />
                </Box>

                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      mb: 0.8,
                    }}
                  >
                    <FlaskConical size={18} style={{ color: "#6366f1" }} />
                    <Typography
                      variant="subtitle1"
                      sx={{
                        fontWeight: 700,
                        color: "#4338ca",
                        fontSize: "1.05rem",
                      }}
                    >
                      {selectedLab.title}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      gap: 1,
                      mb: 1,
                      flexWrap: "wrap",
                    }}
                  >
                    <Chip
                      size="small"
                      label={
                        selectedLab?.estimatedDurationMinutes
                          ? `${selectedLab?.estimatedDurationMinutes} mins`
                          : "-"
                      }
                      sx={{
                        backgroundColor: "#e0e7ff",
                        color: "#4338ca",
                        fontWeight: 600,
                        fontSize: "0.75rem",
                        borderRadius: 1.5,
                      }}
                    />
                    <Chip
                      size="small"
                      label={selectedLab.resourceType}
                      sx={{
                        backgroundColor: "#f3e8ff",
                        color: "#7c3aed",
                        fontWeight: 600,
                        fontSize: "0.75rem",
                        borderRadius: 1.5,
                      }}
                    />
                  </Box>
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#64748b",
                      fontSize: "0.82rem",
                      lineHeight: 1.5,
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                    }}
                  >
                    {selectedLab.description}
                  </Typography>
                </Box>

                <IconButton
                  size="small"
                  onClick={() => setSelectedLab(null)}
                  sx={{
                    color: "#6366f1",
                    "&:hover": { backgroundColor: "#e0e7ff" },
                  }}
                >
                  <img
                    src={assets.closeIcon}
                    alt="remove"
                    width={20}
                    height={20}
                  />
                </IconButton>
              </Paper>
            )}

            <Box>
              {/* Buttons Row */}
              <Stack
                direction="row"
                alignItems="center"
                spacing={3}
                flexWrap="wrap"
                sx={{ mt: 2 }}
              >
                {/* Add Link */}
                <Box
                  onClick={() => setShowLinkBox(!showLinkBox)}
                  className="cameraContainerActivity"
                  sx={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <Link size={20} />
                  <Typography
                    variant="body2"
                    className="uploadHereText"
                    sx={{ fontWeight: 500 }}
                  >
                    Add Link
                  </Typography>
                </Box>

                {/* Upload Files */}
                <Box
                  sx={{
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <input
                    type="file"
                    accept=".pdf,.jpg,.jpeg,.gif,.png,.mp3,.aac,.mp4,.mov,.wmv,.mpeg"
                    id="attachFile"
                    style={{ display: "none" }}
                    onChange={(e) => checkFileSizeForAns(e)}
                  />

                  <label htmlFor="attachFile" style={{ cursor: "pointer" }}>
                    <span className="cameraContainerAddAttachment d-flex align-items-center">
                      <img
                        src={assets.UploadIcon}
                        alt=""
                        style={{ width: "28px" }}
                      />
                      <Typography
                        variant="body2"
                        className="uploadHereText"
                        sx={{ ml: 1, fontWeight: 500 }}
                      >
                        Upload files
                      </Typography>
                    </span>
                  </label>

                  {loader && <CircularProgress size={22} sx={{ ml: 1 }} />}

                  {(errorsize || !isValidFileType) && (
                    <Typography
                      variant="caption"
                      color="error"
                      sx={{ ml: 2, fontWeight: 500 }}
                    >
                      {errorsize
                        ? "File must be under 10MB"
                        : "Invalid file type"}
                    </Typography>
                  )}
                </Box>

                {/* Camera Upload */}
                {!isCameraOpen ? (
                  <Box
                    onClick={() => setIsCameraOpen(true)}
                    className="d-flex align-items-center gap-2 cameraContainerActivity"
                    sx={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <img
                      src="/images/CameranewIcon.png"
                      alt=""
                      style={{ width: "33px" }}
                    />
                    <Typography
                      variant="body2"
                      className="uploadHereText"
                      sx={{ fontWeight: 500 }}
                    >
                      Take Photo
                    </Typography>
                  </Box>
                ) : (
                  <Box
                    className="opened_camera"
                    sx={{
                      mt: 2,
                      width: "100%",
                      position: "relative",
                      borderRadius: 2,
                      border: "1px solid #e0e0e0",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                      overflow: "hidden",
                      backgroundColor: "#fafafa",
                    }}
                  >
                    {/* Close Icon */}
                    <IconButton
                      onClick={() => setIsCameraOpen(false)}
                      size="small"
                      sx={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        zIndex: 10,
                        backgroundColor: "rgba(255,255,255,0.8)",
                        "&:hover": { backgroundColor: "rgba(255,255,255,1)" },
                      }}
                    >
                      <img
                        src={assets.closeIcon}
                        alt="close"
                        width={20}
                        height={20}
                      />
                    </IconButton>

                    {/* Camera Component */}
                    <Box sx={{ position: "relative" }}>
                      <Camera
                        onTakePhoto={handleTakePhoto}
                        idealFacingMode="environment"
                        isImageMirror={false}
                        imageCompression={0.97}
                        isMaxResolution={true}
                        isSilentMode={false}
                        className="custom-camera"
                      />
                    </Box>

                    {/* Camera Error Message */}
                    {cameraError && (
                      <Box
                        sx={{
                          mt: 1.5,
                          mx: "auto",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "#ffebee",
                          border: "1px solid #f44336",
                          color: "#c62828",
                          borderRadius: 1,
                          px: 2,
                          py: 1,
                          width: "fit-content",
                          fontSize: "0.9rem",
                        }}
                      >
                        <ReportProblemRoundedIcon
                          sx={{ mr: 1, fontSize: "1.2rem", color: "#f44336" }}
                        />
                        {cameraError}
                      </Box>
                    )}
                  </Box>
                )}

                {/* Activity Labs — at the END */}
                <Box
                  onClick={() => {
                    setActivityLabsOpen(true);
                  }}
                  sx={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    px: 2,
                    py: 1,
                    borderRadius: 2,
                    backgroundColor: selectedLab ? "#f5f3ff" : "#ffffff",
                    border: selectedLab
                      ? "2px solid #6366f1"
                      : "1px solid #e2e8f0",
                    transition: "all 0.2s",
                    marginLeft: "auto !important",
                    "&:hover": {
                      borderColor: "#6366f1",
                      boxShadow: "0 2px 8px rgba(99,102,241,0.1)",
                    },
                  }}
                >
                  <FlaskConical
                    size={18}
                    style={{
                      color: selectedLab ? "#6366f1" : "#64748b",
                    }}
                  />
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 600,
                      color: selectedLab ? "#4338ca" : "#475569",
                      fontSize: "0.85rem",
                    }}
                  >
                    {selectedLab ? "Change Lab" : "Activity Labs"}
                  </Typography>
                </Box>
              </Stack>

              {/* Attachments List */}
              <Box
                sx={{
                  mt: 2,
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
                  gap: 2,
                }}
              >
                {attach &&
                  attach?.length !== 0 &&
                  attach?.map((attachment) => (
                    <div style={{ margin: "10px" }}>
                      <PdfQTypeDRaft
                        setDraftAttach={setUpdateActivity}
                        updateActivity={updateActivity}
                        editAttachData={draftActivitys}
                        attach={attachment}
                      />
                    </div>
                  ))}
              </Box>
            </Box>
            <div className=" ">
              <div className=" mb-2 mt-3 marks_AR">
                <span style={{ color: "#000A11 !important" }}>
                  Add Correct Answer{" "}
                </span>
              </div>

              <div>
                <div className="hw_mcq_option_box d-flex align-items-center">
                  <input
                    onChange={(e) =>
                      setUpdateActivity((prevState) => ({
                        ...prevState,
                        correctAnswer: {
                          ...prevState.correctAnswer,
                          explanation: e.target.value,
                        },
                      }))
                    }
                    className="hw_add_reason"
                    placeholder="Correct Answer"
                    value={updateActivity.correctAnswer.explanation}
                    maxlength="250"
                  />
                  <div>
                    {loader2 && (
                      <img
                        style={{ width: "32px", height: "32px" }}
                        src="/gif/Loader.gif"
                      />
                    )}

                    <input
                      id="attachFile2"
                      type="file"
                      accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                      style={{ display: "none" }}
                      onChange={(e) => checkFileSize(e)}
                    />
                    <label
                      style={{
                        backgroundColor: "#F0F0F0",
                        borderRadius: "8px",
                        cursor: "pointer",
                        margin: 0,
                      }}
                      className="d-flex align-items-center py-2 px-3"
                      htmlFor={`attachFile2`}
                    >
                      <img src="/images/Attach.svg" alt="" />
                      <span className="hw_mandatory_checkbox">
                        &nbsp;Attach
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              {!isValidFileType && (
                <p id="errorMsg">
                  Please upload a file with a valid extension (pdf, jpg, jpeg,
                  png, pptx, ppt, mp3, mp4), The maximum upload limit is 5
                  files, and the total size should not exceed 10MB.
                </p>
              )}
              <div
                className="mt-2 p-1 pdf_create_activity d-flex"
                style={{
                  maxHeight:
                    updateActivity?.correctAnswer?.attachment.length > 3
                      ? "320px"
                      : "160px",
                }}
              >
                {updateActivity?.correctAnswer?.attachment &&
                  updateActivity?.correctAnswer?.attachment?.map(
                    (obj, index) => (
                      <div style={{ margin: "10px" }}>
                        <AttachActivity
                          closeAttach={setUpdateActivity}
                          activityState={updateActivity}
                          attachMent={attachMent}
                          attachArr={attachState}
                          setAttachment={setAttachment}
                          setAttach={setAttach}
                          attach={obj}
                        />
                      </div>
                    ),
                  )}
              </div>
            </div>
          </div>
        </div>

        <div className="me-4 mt-1 d-grid gap-2 d-md-flex justify-content-md-end">
          <button
            className="btn  m-1 py-2 Next_button_draftAct"
            onClick={() => {
              helper();
            }}
            disabled={isDisableDraft}
          >
            Save as Draft
          </button>
          <button
            className="btn  m-1 py-2 Next_button_publicAct"
            onClick={(e) => setClick(true)}
            disabled={isDisablePublish}
          >
            Publish
          </button>
        </div>
      </div>

      {click && (
        <CreatePublishActivity
          change={setClick}
          createpublishActi={draftActivitys}
          updateActivity={updateActivity}
          selectedLab={selectedLab}
          entryType={entryType}
          selectedGradeScale={selectedGradeScale}
        />
      )}
      {showLinkBox && (
        <AddLinkPopup
          setShowLinkBox={setShowLinkBox}
          onChangeLinkValue={onChangeLinkValue}
          linkValue={linkValue}
          handleSaveLink={handleSaveLink}
        />
      )}

      {/* Activity Labs Dialog */}
      <Dialog
        open={activityLabsOpen}
        onClose={() => setActivityLabsOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: "0 25px 50px -12px rgba(0,0,0,0.15)",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 3,
            py: 2.5,
            borderBottom: "1px solid #f1f5f9",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <FlaskConical size={22} style={{ color: "#6366f1" }} />
            <Typography
              variant="h6"
              sx={{ fontWeight: 700, color: "#1e293b", fontSize: "1.1rem" }}
            >
              Activity Labs
            </Typography>
          </Box>
          <IconButton
            size="small"
            onClick={() => setActivityLabsOpen(false)}
            sx={{ color: "#94a3b8" }}
          >
            <img src={assets.closeIcon} alt="close" width={20} height={20} />
          </IconButton>
        </DialogTitle>

        <DialogContent
          sx={{
            p: 0,
            backgroundColor: "#f8fafc",
            height: "70vh",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Fixed Search Header */}
          <Box
            sx={{
              position: "sticky",
              top: 0,
              zIndex: 20,
              backgroundColor: "#f8fafc",
              px: 3,
              pt: 3,
              pb: 2,
              borderBottom: "1px solid #e2e8f0",
            }}
          >
            <TextField
              fullWidth
              placeholder="Search activities..."
              size="small"
              value={labSearch}
              onChange={(e) => setLabSearch(e.target.value)}
              sx={{
                mb: 2,
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                  backgroundColor: "#ffffff",
                  fontSize: "0.9rem",
                },
              }}
            />

            <Typography
              variant="body2"
              sx={{
                color: "#64748b",
                fontSize: "0.8rem",
                fontWeight: 500,
              }}
            >
              {filteredLabs.length} activities available
            </Typography>
          </Box>

          {/* Scrollable Activities */}
          <Box
            onScroll={(e) => {
              const bottom =
                e.target.scrollHeight - e.target.scrollTop <=
                e.target.clientHeight + 50;

              if (bottom && visibleLabsCount < filteredLabs.length) {
                setVisibleLabsCount((prev) => prev + 10);
              }
            }}
            sx={{
              flex: 1,
              overflowY: "auto",
              px: 3,
              py: 2,

              "&::-webkit-scrollbar": {
                width: "8px",
              },

              "&::-webkit-scrollbar-thumb": {
                background: "#cbd5e1",
                borderRadius: "10px",
              },
            }}
          >
            <Stack spacing={2}>
              {labsLoading ? (
                <div className="text-center py-4">
                  <CircularProgress size={30} />
                </div>
              ) : (
                filteredLabs.slice(0, visibleLabsCount).map((lab) => {
                  const isSelected = selectedLab?.id === lab.id;

                  return (
                    <Paper
                      key={lab.id}
                      elevation={0}
                      onClick={() => setSelectedLab(isSelected ? null : lab)}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2.5,
                        p: 2.5,
                        borderRadius: 2.5,
                        border: isSelected
                          ? "2px solid #6366f1"
                          : "1px solid #e2e8f0",
                        backgroundColor: isSelected ? "#f5f3ff" : "#ffffff",
                        cursor: "pointer",
                        transition: "all 0.2s ease",

                        "&:hover": {
                          borderColor: "#c4b5fd",
                          boxShadow: "0 4px 12px rgba(99,102,241,0.08)",
                        },
                      }}
                    >
                      <Radio
                        checked={isSelected}
                        onChange={() => setSelectedLab(isSelected ? null : lab)}
                        sx={{
                          color: isSelected ? "#6366f1" : "#cbd5e1",
                          "&.Mui-checked": {
                            color: "#6366f1",
                          },
                          p: 0.5,
                        }}
                      />

                      {/* Thumbnail */}
                      <Box
                        sx={{
                          width: 130,
                          height: 85,
                          flexShrink: 0,
                          borderRadius: 2,
                          overflow: "hidden",
                          border: "1px solid #e2e8f0",
                          backgroundColor: "#f1f5f9",
                        }}
                      >
                        <img
                          src={lab.thumbnailUrl}
                          alt={lab.title}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                          onError={(e) => {
                            e.target.style.display = "none";
                          }}
                        />
                      </Box>

                      {/* Content */}
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography
                          variant="h6"
                          sx={{
                            fontSize: "1.05rem",
                            fontWeight: 700,
                            color: "#1e293b",
                            mb: 0.8,
                          }}
                        >
                          {lab.title}
                        </Typography>

                        <Box
                          sx={{
                            display: "flex",
                            gap: 1,
                            mb: 1.2,
                            flexWrap: "wrap",
                          }}
                        >
                          <Chip
                            size="small"
                            label={
                              lab?.estimatedDurationMinutes
                                ? `${lab.estimatedDurationMinutes} mins`
                                : "-"
                            }
                            sx={{
                              backgroundColor: "#e0e7ff",
                              color: "#4338ca",
                              fontWeight: 600,
                              fontSize: "0.75rem",
                              borderRadius: 1.5,
                            }}
                          />
                        </Box>

                        <Typography
                          variant="body2"
                          sx={{
                            color: "#64748b",
                            fontSize: "0.82rem",
                            lineHeight: 1.5,
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                          }}
                        >
                          {lab.description}
                        </Typography>
                      </Box>

                      {/* View Details */}
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();

                          const previewData = {
                            selectedLab: lab,
                            activityData: {
                              title: updateActivity.updateTittle,
                              description: updateActivity.description,
                              className: draftActivitys?.standard_id?.name,
                              subjectName: draftActivitys?.subject_id?.name,
                              chapterName:
                                draftActivitys?.chapter_id?.chapterName || "",
                              duration:
                                draftActivitys?.duration || "20 minutes",
                            },
                          };

                          localStorage.setItem(
                            "activityPreviewData",
                            JSON.stringify(previewData),
                          );

                          const features = [
                            "toolbar=no",
                            "location=no",
                            "directories=no",
                            "status=no",
                            "menubar=no",
                            "scrollbars=yes",
                            "resizable=yes",
                            "fullscreen=yes",
                            `width=${window.screen.availWidth}`,
                            `height=${window.screen.availHeight}`,
                            "top=0",
                            "left=0",
                          ].join(",");

                          const newWindow = window.open(
                            "/activity-lab-preview.html",
                            "_blank",
                            features,
                          );

                          if (newWindow) {
                            newWindow.moveTo(0, 0);

                            newWindow.resizeTo(
                              window.screen.availWidth,
                              window.screen.availHeight,
                            );

                            newWindow.focus();
                          }
                        }}
                      >
                        View Details
                      </Button>
                    </Paper>
                  );
                })
              )}

              {/* Empty */}
              {filteredLabs.length === 0 && (
                <Box sx={{ textAlign: "center", py: 6 }}>
                  <Typography variant="body2" sx={{ color: "#94a3b8" }}>
                    No activities found matching your search
                  </Typography>
                </Box>
              )}
            </Stack>

            {/* Bottom Loader */}
            {visibleLabsCount < filteredLabs.length && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  py: 2,
                }}
              >
                <CircularProgress size={24} />
              </Box>
            )}
          </Box>
        </DialogContent>

        <DialogActions
          sx={{
            px: 3,
            py: 2.5,
            borderTop: "1px solid #f1f5f9",
            backgroundColor: "#ffffff",
          }}
        >
          <Button
            variant="outlined"
            onClick={() => setActivityLabsOpen(false)}
            sx={{
              textTransform: "none",
              borderRadius: 2,
              px: 3,
              fontWeight: 600,
              borderColor: "#e2e8f0",
              color: "#64748b",
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => setActivityLabsOpen(false)}
            disabled={!selectedLab}
            sx={{
              textTransform: "none",
              borderRadius: 2,
              px: 3,
              fontWeight: 600,
              backgroundColor: "#6366f1",
              "&:hover": { backgroundColor: "#4f46e5" },
              boxShadow: "0 4px 14px rgba(99,102,241,0.35)",
            }}
          >
            {selectedLab ? `Select: ${selectedLab.title}` : "Select Activity"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
